/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Manager_Owner_Cannot_DeleteInputs */

const en_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} is the team owner and can not be deleted`)
};

const fr_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} est le propriétaire de l’équipe et ne peut pas être supprimé`)
};

const de_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} ist der Teambesitzer und kann nicht gelöscht werden.`)
};

const it_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} è il proprietario del team e non può essere eliminato`)
};

const ru_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} является владельцем команды и не может быть удален.`)
};

const es_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} es el propietario del equipo y no se puede eliminar`)
};

const zh_cn2_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} 是团队所有者，无法删除。`)
};

const ja_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} はチームオーナーなので削除できません`)
};

const hi_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} टीम का स्वामी है और इसे हटाया नहीं जा सकता।`)
};

const pt_pt2_team_manager_owner_cannot_delete = /** @type {(inputs: Team_Manager_Owner_Cannot_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} é o proprietário da equipe e não pode ser excluído.`)
};

/**
* | output |
* | --- |
* | "{email} is the team owner and can not be deleted" |
*
* @param {Team_Manager_Owner_Cannot_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_owner_cannot_delete = /** @type {((inputs: Team_Manager_Owner_Cannot_DeleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Owner_Cannot_DeleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_owner_cannot_delete(inputs)
	if (locale === "de") return de_team_manager_owner_cannot_delete(inputs)
	if (locale === "it") return it_team_manager_owner_cannot_delete(inputs)
	if (locale === "ru") return ru_team_manager_owner_cannot_delete(inputs)
	if (locale === "es") return es_team_manager_owner_cannot_delete(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_owner_cannot_delete(inputs)
	if (locale === "ja") return ja_team_manager_owner_cannot_delete(inputs)
	if (locale === "hi") return hi_team_manager_owner_cannot_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_owner_cannot_delete(inputs)
	return en_team_manager_owner_cannot_delete(inputs)
});